import React, { useContext } from "react";
import "./ProjectDetails.css";
import { ProjectContext } from "../context/ProjectContext";

const FinancialDetails = () => {
  const { projectDetails } = useContext(ProjectContext);

  if (!projectDetails) return null;

  const approved = Number(projectDetails.approved_amount || 0);
  const utilized = Number(projectDetails.utilized_amount || 0);
  const remaining = approved - utilized;
const formatAmount = (amount) => {
  if (!amount) return "₹0";

  if (amount >= 10000000) {
    return `₹${(amount / 10000000).toFixed(2)} Cr`;
  } else if (amount >= 100000) {
    return `₹${(amount / 100000).toFixed(2)} Lakh`;
  } else {
    return `₹${amount.toLocaleString("en-IN")}`;
  }
};
const getFinancialYear = (dateString) => {
  if (!dateString) return "—";

  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Jan = 1

  if (month >= 4) {
    return `FY ${year}-${String(year + 1).slice(-2)}`;
  }

  return `FY ${year - 1}-${String(year).slice(-2)}`;
};
  return (
    <div className="card csr-card financial-card">
      <div className="csr-card-header">
        <div className="csr-icon green">
          <i className="fa-solid fa-indian-rupee-sign"></i>
        </div>
        <h5 className="mb-0">Financial Details</h5>
      </div>

      <div className="finance-tile blue">
        <span className="finance-label">Approved CSR Amount</span>
        <div className="finance-value">{formatAmount(approved)}</div>
      </div>

      <div className="finance-tile green">
        <span className="finance-label">Utilized Amount</span>
        <div className="finance-value">{formatAmount(utilized)}</div>
      </div>

      <div className="finance-tile yellow">
        <span className="finance-label">Remaining Amount</span>
        <div className="finance-value">{formatAmount(remaining)}</div>
      </div>

      <div className="finance-year">
        <span>Financial Year</span>
      <strong>
  {getFinancialYear(projectDetails.start_year)}
</strong>
      </div>
    </div>
  );
};

export default FinancialDetails;
